<template>
  <!-- 特集ページのサムネイル上に重ねるタイトルオーバーレイ。
       FeaturedThumbnailImage と組み合わせて使う前提で、親要素は position: relative を持つこと。
       タイポは HeaderExperiencesDropdown と統一（Spectral 17/24 white）。
       親要素に `group` クラスがあれば、ホバー時にアンダーラインが入る。
       z-[1] は iOS Safari のコンポジットバグ対策（画像レイヤーの裏に隠れないよう明示的に重ね順を指定。JCAT-5320） -->
  <p class="pointer-events-none absolute inset-0 z-[1] flex flex-col items-center justify-center px-2 text-center font-Spectral text-[17px] leading-6 text-white group-hover:underline">
    <slot />
  </p>
</template>

<script setup lang="ts"></script>
